import React from "react";
import { Box, TextField, MenuItem, IconButton, Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import { ALLOWED_STATUSES, ALLOWED_BILLING_PERIODS } from "./validators";
import AudiencePicker from "./AudiencePicker";
import { IssueBanner } from "./StepSection";

// Step 1 — who the product is for and what the checkout card says about it.
const IdentityStep = ({
  classes, form, set, isEdit, showErrors, basicsErr,
  nameError, setNameError, billingLocked, lockMark, onBillingPeriod,
  featInput, setFeatInput, onAddFeature, onRemoveFeature,
  audienceLabels, setAudienceLabels, issues, onContinue,
}) => (
  <>
    <Box className={classes.grid2}>
      <div>
        <span className={classes.fieldLabel}>Internal name</span>
        <TextField className={classes.input} fullWidth variant="outlined" size="small"
          placeholder="Internal reference name"
          value={form.name}
          error={(showErrors && !!basicsErr.name) || !!nameError}
          helperText={nameError || (showErrors ? basicsErr.name : "")}
          onChange={(e) => { setNameError(""); set({ name: e.target.value }); }} />
      </div>
      <div>
        <span className={classes.fieldLabel}>Billing period{lockMark()}</span>
        <TextField className={classes.input} select fullWidth variant="outlined" size="small"
          disabled={billingLocked}
          value={form.billing.period} onChange={(e) => onBillingPeriod(e.target.value)}>
          {ALLOWED_BILLING_PERIODS.map((p) => <MenuItem key={p} value={p}>{p}</MenuItem>)}
        </TextField>
      </div>
    </Box>
    <Box className={classes.grid2}>
      {isEdit && (
        <div>
          <span className={classes.fieldLabel}>Status</span>
          <TextField className={classes.input} select fullWidth variant="outlined" size="small"
            value={form.status} onChange={(e) => set({ status: e.target.value })}>
            {ALLOWED_STATUSES.map((s) => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </TextField>
        </div>
      )}
    </Box>
    <div style={{ marginTop: 16 }}>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Audience</div>
      <AudiencePicker
        value={form.audience}
        onChange={(a) => set({ audience: a })}
        labelCache={audienceLabels}
        setLabelCache={setAudienceLabels}
      />
    </div>
    <div>
      <span className={classes.fieldLabel}>Plan title <span className={classes.hint}>the headline on the checkout card</span></span>
      <TextField className={classes.input} fullWidth variant="outlined" size="small"
        value={form.planTitle} error={showErrors && !!basicsErr.planTitle} helperText={showErrors ? basicsErr.planTitle : ""}
        onChange={(e) => set({ planTitle: e.target.value })} />
    </div>
    <div>
      <span className={classes.fieldLabel}>Subtitle</span>
      <TextField className={classes.input} fullWidth variant="outlined" size="small"
        value={form.planSubtitle} error={showErrors && !!basicsErr.planSubtitle} helperText={showErrors ? basicsErr.planSubtitle : ""}
        onChange={(e) => set({ planSubtitle: e.target.value })} />
    </div>
    <div>
      <span className={classes.fieldLabel}>Features <span className={classes.hint}>added one at a time — shown as ticks on the card</span></span>
      <Box className={classes.featList}>
        {form.features.length === 0 && <div className={classes.hint}>No features yet — add your first below.</div>}
        {form.features.map((f, i) => (
          <Box key={i} className={classes.featRow}>
            <span className={classes.tick}>✓</span>
            <span className={classes.featTxt}>{f}</span>
            <IconButton size="small" className={classes.removeBtn} onClick={() => onRemoveFeature(i)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>
      <Box className={classes.featAdd} mt={1}>
        <TextField className={classes.input} fullWidth variant="outlined" size="small"
          placeholder="Type a feature and press Enter" value={featInput}
          error={showErrors && !!basicsErr.features}
          onChange={(e) => setFeatInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); onAddFeature(); } }} />
        <Button variant="outlined" startIcon={<AddIcon />} onClick={onAddFeature}>Add</Button>
      </Box>
    </div>
    <IssueBanner issues={issues} classes={classes} />
    <Box className={classes.continueRow}>
      <Button className={classes.continueBtn} variant="contained" onClick={onContinue}>Continue</Button>
    </Box>
  </>
);

export default IdentityStep;
